import standard from './standard'

export const providers = [standard]

export default providers
